import React from "react";
import OverlapSection from "../section/OverlapSection";
import imageSrc from "../../assets/images/lostCat.jpg";

const Coordination = () => {
  return (
    <section id="coordination" className="feature-section-anchor">
      <OverlapSection
        layoutClass="toLeft"
        imageUrl={imageSrc}
        mainTitle="HELP MOVES FASTER TOGETHER"
        backText={
          "Join rescue groups, chat with volunteers and NGOs, receive post updates, and coordinate the next step while everyone has the same case details."
        }
      />
    </section>
  );
};

export default Coordination;
